import { render, staticRenderFns } from "./reviewVideo.vue?vue&type=template&id=640fe410&scoped=true&"
import script from "./reviewVideo.vue?vue&type=script&lang=js&"
export * from "./reviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./reviewVideo.vue?vue&type=style&index=0&id=640fe410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fe410",
  null
  
)

component.options.__file = "reviewVideo.vue"
export default component.exports